<template>
  <div class="price-inventory-normal-container">
    <el-table v-if="tableVisible" :data="specTabData" :span-method="objectSpanMethod" border style="width: fit-content; margin-top: 20px">
      <el-table-column label="规格图片" width="140">
        <template slot-scope="scope">
          <el-upload
            :action="`${env.VUE_APP_fileserver}persistentUpload`"
            :show-file-list="false"
            :on-success="(res) => uploadSuccess(res, scope)"
            :before-upload="uploadBefore"
          >
            <div v-if="scope.row.skuPicUrl" class="el-upload-list--picture-card">
              <img :src="scope.row.skuPicUrl" class="skuPic" />
              <div class="el-upload-list__item-actions">
                <span class="el-upload-list__item-delete" @click.stop="scope.row.skuPicUrl = ''">
                  <i class="el-icon-delete"></i>
                </span>
              </div>
            </div>
            <i v-else class="el-icon-plus skuPic-uploader-icon"></i>
          </el-upload>
        </template>
      </el-table-column>
      <el-table-column v-for="column in dynamicColumn" :key="column.prop" :prop="column.prop" :label="column.label" width="140"> </el-table-column>
      <el-table-column v-if="isOA" label="代号名称" prop="qlwName" width="140"> </el-table-column>
      <el-table-column width="150">
        <template #header>
          <span><span class="xingTips">*</span>销售单位 &nbsp;</span>
          <el-popover v-model="batchUnitObj.batchUnitShow" placement="top" width="180" trigger="click">
            <div>
              <h4>批量修改销售单位</h4>
              <el-select
                filterable
                style="margin-top: 7px"
                size="mini"
                v-model="batchUnitObj.batchUnitCode"
                placeholder="请选择销售单位"
                @change="bacthUnitSelectChange"
              >
                <el-option v-for="unitItem in unitsList" :key="unitItem.unitsCode" :label="unitItem.unitsName" :value="unitItem.unitsCode"> </el-option>
              </el-select>
              <p class="batchTips" v-if="batchUnitObj.batchUnitShowError">请选择销售单位</p>
              <div class="bottomBtnsBox text-center">
                <el-button size="mini" @click="batchUnitObj.batchUnitShow = false">取消</el-button>
                <el-button size="mini" type="primary" @click="batchUnitSure">确定</el-button>
              </div>
            </div>
            <template #reference>
              <i v-if="!isOA" class="el-icon-edit-outline"></i>
            </template>
          </el-popover>
          <div class="fb-normal f12">按销售单位下单结算</div>
        </template>
        <template slot-scope="scope">
          <el-select filterable v-model="scope.row.skuUnit" placeholder="销售单位" @change="unitSelectChange($event, scope.row)">
            <el-option v-for="unitItem in unitsList" :key="unitItem.unitsCode" :label="unitItem.unitsName" :value="unitItem.unitsCode"> </el-option>
          </el-select>
        </template>
      </el-table-column>
      <el-table-column v-if="shopConfig && shopConfig.funcSettingMap.is_off_stand != '0'" width="320">
        <template #header>
          <!-- 顶部批量修改计量单位 -->
          <span>计量单位 &nbsp;</span>
          <el-popover v-model="batchUnitRatioObj.unitRatioShow" placement="top" width="300" trigger="click">
            <div>
              <h4>批量修改计量单位</h4>
              <div class="flex items-center" style="margin-top: 7px">
                <el-input
                  size="mini"
                  v-model="batchUnitRatioObj.ratio"
                  placeholder="请填写换算值"
                  class="mar10-r flex-shrink"
                  style="width: 120px"
                  oninput="value=value.replace(/[^\d^\.]+/g,'').replace('.','$#$').replace(/\./g,'').replace('$#$','.').replace(/^(\-)*(\d+)\.(\d\d).*$/,'$1$2.$3')"
                ></el-input>
                <el-select clearable filterable placeholder="计量单位" style="width: 100px" size="mini" v-model="batchUnitRatioObj.unit">
                  <el-option v-for="unitItem in unitsList" :key="unitItem.unitsCode" :label="unitItem.unitsName" :value="unitItem.unitsCode"> </el-option>
                </el-select>
              </div>
              <div class="bottomBtnsBox">
                <el-button size="mini" @click="batchUnitRatioObj.unitRatioShow = false">取消</el-button>
                <el-button size="mini" type="primary" @click="batchUnitRatioSure">确定</el-button>
              </div>
            </div>
            <template #reference>
              <i class="el-icon-edit-outline"></i>
            </template>
          </el-popover>
        </template>
        <template slot-scope="scope">
          <div class="flex nowrap items-center">
            <div class="pad5-r">每</div>
            <el-input
              v-model="scope.row.unitRatio"
              placeholder="请填写换算值"
              class="mar10-r flex-shrink"
              style="width: 120px"
              oninput="value=value.replace(/[^\d^\.]+/g,'').replace('.','$#$').replace(/\./g,'').replace('$#$','.').replace(/^(\-)*(\d+)\.(\d\d).*$/,'$1$2.$3')"
            ></el-input>
            <el-select style="width: 80px" class="flex-shrink" filterable v-model="scope.row.sUnit" placeholder="计量单位">
              <el-option v-for="unitItem in unitsList" :key="unitItem.unitsCode" :label="unitItem.unitsName" :value="unitItem.unitsCode"> </el-option>
            </el-select>
            <div class="pad5-l">≈1{{ scope.row && scope.row.spec && scope.row.spec.split("/")[1] }}</div>
          </div>
        </template>
      </el-table-column>
      <el-table-column v-if="!isOA" width="190">
        <template #header>
          <!-- 顶部批量修改价格 -->
          <span><span class="xingTips">*</span>商品价格 &nbsp;</span>
          <el-popover v-model="batchPriceObj.batchPriceShow" placement="top" width="280" trigger="click">
            <div>
              <h4>批量修改价格</h4>
              <div style="display: flex; margin-top: 7px; margin-left: 7px">
                <el-select style="width: 100px" size="mini" v-model="batchPriceObj.batchSelectType">
                  <el-option v-for="selectOptions in batchPriceOptions" :key="selectOptions.id" :label="selectOptions.name" :value="selectOptions.id">
                  </el-option>
                </el-select>

                <el-input
                  style="width: 150px; margin-left: 10px"
                  size="mini"
                  type="number"
                  :min="0"
                  v-model="batchPriceObj.batchPrice"
                  placeholder="商品价格"
                  @input="batchPriceInput"
                  @change="batchPriceChange"
                ></el-input>
              </div>
              <p class="batchTips" v-if="batchPriceObj.batchPriceNullError || batchPriceObj.batchPriceFuError">
                {{ batchPriceObj.batchPriceNullError ? "请填写价格" : "价格不可为负数" }}
              </p>
              <div class="text-center bottomBtnsBox">
                <el-button size="mini" @click="batchPriceObj.batchPriceShow = false">取消</el-button>
                <el-button size="mini" type="primary" @click="batchPriceSure">确定</el-button>
              </div>
            </div>
            <template #reference>
              <i class="el-icon-edit-outline"></i>
            </template>
          </el-popover>
        </template>
        <template slot-scope="scope">
          <el-input
            type="number"
            :min="0"
            v-model="scope.row.price"
            placeholder="商品价格"
            @input="skuPriceInput(scope.row)"
            @change="skuPriceChange(scope.row)"
            :disabled="isOA || (!isOA && !cateModel)"
          ></el-input>
        </template>
      </el-table-column>
      <el-table-column width="190">
        <template #header>
          <!-- 顶部批量修改价格 -->
          <span>起订量 &nbsp;</span>
          <el-popover v-if="cateModel" v-model="batchMinOrderQuantityObj.batchMinOrderQuantityShow" placement="top" width="230" trigger="click">
            <div>
              <h4>批量修改起订量</h4>
              <el-input
                size="mini"
                type="number"
                :min="0"
                v-model="batchMinOrderQuantityObj.batchMinOrderQuantity"
                :placeholder="shopConfig && shopConfig.goodsAmountDigit == '0' ? '请输入1以上的整数' : '请输入起订量'"
                @input="batchMinOrderQuantityInput"
              ></el-input>
              <div class="flex justify-center pad10-t">
                <el-button
                  size="mini"
                  @click="
                    batchMinOrderQuantityObj.batchMinOrderQuantityShow = false;
                    batchMinOrderQuantityObj.batchMinOrderQuantity = '';
                  "
                  >取消</el-button
                >
                <el-button size="mini" type="primary" @click="batchMinOrderQuantitySure">确定</el-button>
              </div>
            </div>
            <template #reference>
              <i class="el-icon-edit-outline"></i>
            </template>
          </el-popover>
        </template>
        <template slot-scope="scope">
          <el-input
            type="number"
            :min="0"
            :max="99999999"
            v-model="scope.row.minOrderQuantity"
            :placeholder="shopConfig && shopConfig.goodsAmountDigit == '0' ? '请输入1以上的整数' : '请输入起订量'"
            @input="skuMinOrderQuantityInput(scope.row)"
            :disabled="!cateModel"
          ></el-input>
        </template>
      </el-table-column>
      <el-table-column v-if="isOA" label="库存方式" width="140">
        <template #header>
          <el-tooltip effect="dark" placement="top">
            <template #content>
              不启用库存:买家下单不会受到库存数量限制! <br />
              启用售卖库存:用户下单,根据库存数量进行判断!<br />
              启用管理库存:用户下单,根据库存数量进行判断,用户下单不会减少系统管理库存!<br />
            </template>
            <i class="el-icon-info"></i>
          </el-tooltip>
          &nbsp;库存方式
        </template>
        <template slot-scope="scope">
          <el-select v-model="scope.row.stockType" @change="stockSelectChange($event, scope.row)">
            <el-option v-for="stockItem in stockTypeArr" :key="stockItem.stockType" :label="stockItem.stockTypeName" :value="stockItem.stockType"> </el-option>
          </el-select>
        </template>
      </el-table-column>
      <el-table-column width="140">
        <template #header>
          <!-- 顶部批量修改库存 -->
          <span><span class="xingTips">*</span>商品库存 &nbsp;</span>
          <el-popover v-model="batchStockObj.batchStockShow" placement="top" width="230" trigger="click">
            <div>
              <h4>批量修改库存</h4>
              <div style="display: flex; margin-top: 7px">
                <el-select style="width: 100px" size="mini" v-model="batchStockObj.batchSelectType">
                  <el-option v-for="selectOptions in batchStockOptions" :key="selectOptions.id" :label="selectOptions.name" :value="selectOptions.id">
                  </el-option>
                </el-select>

                <el-input
                  style="width: 100px; margin-left: 10px"
                  size="mini"
                  v-model="batchStockObj.batchStock"
                  maxlength="9"
                  placeholder="商品库存"
                  oninput="value=value.replace(/[^\d]/g,'')"
                  @input="batchStockInput"
                  @change="batchStockChange"
                ></el-input>
              </div>
              <p class="batchTips" v-if="batchStockObj.batchStockNullError || batchStockObj.batchStockFuError">
                {{ batchStockObj.batchStockNullError ? "请填写库存" : "库存不可为负数" }}
              </p>
              <div class="bottomBtnsBox text-center">
                <el-button size="mini" @click="batchStockObj.batchStockShow = false">取消</el-button>
                <el-button size="mini" type="primary" @click="batchStockSure">确定</el-button>
              </div>
            </div>
            <template #reference>
              <i v-if="!isOA" class="el-icon-edit-outline"></i>
            </template>
          </el-popover>
        </template>
        <template slot-scope="scope">
          <el-input
            v-model="scope.row.stock"
            maxlength="9"
            placeholder="商品库存"
            oninput="value=value.replace(/[^\d]/g,'')"
            @input="skuStockInput"
            @change="skuStockChange(scope.row)"
            :disabled="scope.row.stockType != 1"
          ></el-input>
        </template>
      </el-table-column>
      <el-table-column width="140" v-if="shopConfig && shopConfig.funcSettingMap.is_allow_unreal_sales == '1'">
        <template #header>
          <!-- 顶部批量修改虚拟销量 -->
          <span>虚拟销量 &nbsp;</span>
          <el-popover v-model="batchVirtualObj.batchsalesVolumeUnrealShow" placement="top" width="230" trigger="click">
            <div>
              <h4>批量修改虚拟销量</h4>
              <el-input
                style="margin-top: 7px"
                size="mini"
                type="number"
                :min="0"
                v-model="batchVirtualObj.batchsalesVolumeUnreal"
                placeholder="虚拟销量"
                oninput="value=value.replace(/[^\d^\.]+/g,'').replace('.','$#$').replace(/\./g,'').replace('$#$','').replace(/^(\-)*(\d+)\.(\d\d).*$/,'$1$2')"
              ></el-input>
              <div class="bottomBtnsBox text-center">
                <el-button size="mini" @click="batchVirtualObj.batchsalesVolumeUnrealShow = false">取消</el-button>
                <el-button size="mini" type="primary" @click="batchsalesVolumeUnrealSure">确定</el-button>
              </div>
            </div>
            <template #reference>
              <i class="el-icon-edit-outline"></i>
            </template>
          </el-popover>
        </template>
        <template slot-scope="scope">
          <el-input
            type="number"
            :min="0"
            v-model="scope.row.salesVolumeUnreal"
            placeholder="虚拟销量"
            oninput="value=value.replace(/[^\d^\.]+/g,'').replace('.','$#$').replace(/\./g,'').replace('$#$','').replace(/^(\-)*(\d+)\.(\d\d).*$/,'$1$2')"
          ></el-input>
        </template>
      </el-table-column>
      <el-table-column label="商品编码" width="140">
        <template slot-scope="scope">
          <el-input v-model="scope.row.relationNo" placeholder="商品编码" @input="skuRelationNoInput"></el-input>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  props: {
    availableSpecList: {
      type: Array,
    },
    isOA: {
      type: Boolean,
    },
  },
  data() {
    return {
      tableVisible: true,
      env: process.env,
      specTabData: [], //table列表需要的数据
      dynamicColumn: [], //动态列,用于动态展示规格项的名称
      batchUnitObj: {
        batchUnitCode: "",
        batchUnitSpec: "",
        batchUnitShow: false,
        batchUnitShowError: false,
      }, // 批量修改计量单位
      batchPriceObj: {
        batchPrice: "",
        batchSelectType: "1",
        batchPriceShow: false,
        batchPriceNullError: false,
        batchPriceFuError: false,
      }, // 批量修改价格
      batchMinOrderQuantityObj: {
        batchMinOrderQuantity: "",
        batchMinOrderQuantityShow: false,
      }, // 批量修改起订量
      batchStockObj: {
        batchStock: "",
        batchSelectType: "1",
        batchStockShow: false,
        batchStockNullError: false,
        batchStockFuError: false,
      }, // 批量修改虚拟销量
      batchVirtualObj: {
        batchSalesVolumeUnreal: "",
        batchsalesVolumeUnrealShow: false,
      }, // 批量修改库存
      batchPriceOptions: [
        {
          id: "1",
          name: "统一价格",
        },
        {
          id: "2",
          name: "批量增加",
        },
        {
          id: "3",
          name: "批量减少",
        },
      ],
      batchStockOptions: [
        {
          id: "1",
          name: "统一库存",
        },
        {
          id: "2",
          name: "批量增加",
        },
        {
          id: "3",
          name: "批量减少",
        },
      ],
      // 批量修改计量单位
      batchUnitRatioObj: {
        unitRatioShow: false,
        unit: "",
        ratio: "",
      },
    };
  },
  computed: {
    ...mapState("publishGoods/publishGoods", ["unitsList", "qlwGoodsName", "stockTypeArr", "cateModel", "shopConfig"]),
  },
  watch: {
    //有效的规格项和值
    availableSpecList: {
      handler: function (availableSpecList) {
        const specTabData = [];
        const dynamicColumn = [];

        if (availableSpecList.length === 0) {
          return;
        }
        let newResult = availableSpecList.reduce(
          (a, b) => {
            let res = [];
            a.map((x) => {
              b.specValue.map((y) => {
                res.push({ ...x, [b.specType]: y });
              });
            });
            return res;
          },
          [{}]
        );

        const keys = Object.keys(newResult[0]);

        for (let index = 0; index < keys.length; index++) {
          const keyLabel = keys[index];
          dynamicColumn.push({
            label: keyLabel,
            prop: `specVal${index}`,
          });
        }

        for (let index = 0; index < newResult.length; index++) {
          const skuObj = newResult[index];
          const specObj = {};
          for (const key in skuObj) {
            if (Object.hasOwnProperty.call(skuObj, key)) {
              const element = skuObj[key];
              const dyObj = dynamicColumn.find((dyColumn) => dyColumn.label === key);
              specObj[dyObj.prop] = element;
            }
          }
          specObj.stockType = 1;
          specObj.minOrderQuantity = specObj.minOrderQuantity == 0 ? "" : specObj.minOrderQuantity;
          specTabData.push(specObj);
        }

        if (!(!this.specTabData.length || this.dynamicColumn.length != dynamicColumn.length)) {
          const { specTabData: specTabDataThis } = this;
          console.log("specTabData", specTabData);
          console.log("specTabDataThis", specTabDataThis);
          specTabData.forEach((item, index) => {
            const itemTem = JSON.parse(JSON.stringify(item));
            delete itemTem.stockType;
            const str = JSON.stringify(itemTem).replace(/[{}]/gi, "");
            specTabDataThis.forEach((item2) => {
              console.log("item2", item2);
              if (
                JSON.stringify(item2).indexOf(str) != -1 ||
                (str.indexOf("specVal1") == -1 && specTabDataThis[index] && specTabDataThis[index].id == item2.id)
              ) {
                console.log("str", str);
                specTabData[index] = {
                  ...item2,
                  ...item,
                  minOrderQuantity: item2.minOrderQuantity == 0 ? "" : item2.minOrderQuantity,
                };
              }
            });
          });
        }

        this.specTabData = specTabData;
        this.dynamicColumn = dynamicColumn;
      },
      deep: true,
      immediate: true,
    },
    //oa商品,会有一列企联网商品名
    qlwGoodsName(newVal) {
      this.specTabData.forEach((item) => {
        const qlwTempArr = newVal.filter((qlwNameObj) => item.id == qlwNameObj.goodsId);
        item.qlwName = qlwTempArr[0] && qlwTempArr[0].name ? qlwTempArr[0].name : "";
      });
      this.specTabData = [...this.specTabData];
    },
    //修改分类，影响价格、起订量小数位数
    shopConfig(newVal, oldVal) {
      this.tableVisible = false;
      if (!oldVal || (newVal && oldVal && (newVal.goodsPriceDigit != oldVal.goodsAmountDigit || newVal.goodsPriceDigit != oldVal.goodsPriceDigit))) {
        this.batchPriceObj.batchPrice = "";
        if (oldVal) {
          this.specTabData.forEach((item) => {
            item.price = "";
          });
        }

        this.specTabData = [...this.specTabData];
      }

      //当页面数据加完完毕后
      this.$nextTick(() => {
        this.tableVisible = true;
      });
    },
    isOA(newVal) {
      if (newVal) {
        this.specTabData.forEach((item) => {
          item.price = "";
        });
        this.specTabData = [...this.specTabData];
      }
    },
  },
  methods: {
    //选择完计量单位,拼个中文字符串
    unitSelectChange(unitsCode, skuObj) {
      const unitItem = this.unitsList.find((item) => item.unitsCode === unitsCode);
      skuObj.spec = `元/${unitItem.unitsName}`;
      this.specTabData = [...this.specTabData];
    },
    //批量修改计量单位的error tips提示
    bacthUnitSelectChange() {
      this.batchUnitObj.batchUnitShowError = !this.batchUnitObj.batchUnitCode;
    },
    //确认批量修改计量单位
    batchUnitSure() {
      if (!this.batchUnitObj.batchUnitCode) {
        this.batchUnitObj.batchUnitShowError = true;
        return;
      }
      if (!this.availableSpecList.length) {
        this.$message.error("请先添加规格数据!");
        return;
      }
      const unitItem = this.unitsList.find((item) => item.unitsCode === this.batchUnitObj.batchUnitCode);
      this.batchUnitObj.batchUnitSpec = `元/${unitItem.unitsName}`;
      this.specTabData.forEach((item, index) => {
        this.$set(this.specTabData[index], "skuUnit", this.batchUnitObj.batchUnitCode);
        this.$set(this.specTabData[index], "spec", this.batchUnitObj.batchUnitSpec);
      });
      this.batchUnitObj.batchUnitShow = false;
    },
    //批量修改价钱,控制不超过六位小数,及errortips
    batchPriceInput() {
      if (this.batchPriceObj.batchPrice.indexOf("-") != -1) {
        this.batchPriceObj.batchPrice = this.batchPriceObj.batchPrice.replaceAll("-", "");
      }
      const priceArr = this.batchPriceObj.batchPrice.split(".");
      if (priceArr.length <= 1) {
        return;
      }
      const goodsPriceDigit = 6;
      let xiaoshu = priceArr[1];
      if (xiaoshu.length > goodsPriceDigit) {
        xiaoshu = xiaoshu.substr(0, goodsPriceDigit);
        this.batchPriceObj.batchPrice = `${priceArr[0]}.${xiaoshu}`;
      }
      this.batchPriceObj.batchPriceNullError = !this.batchPriceObj.batchPrice;
    },
    //批量修改价钱,整数补两个0,一位小数补一个0
    batchPriceChange() {
      const priceArr = this.batchPriceObj.batchPrice.split(".");
      //如果是整数,补两个0
      if (priceArr.length <= 1) {
        if (priceArr[0].length) {
          this.batchPriceObj.batchPrice = `${this.batchPriceObj.batchPrice}.00`;
        }
        return;
      }
      const xiaoshu = priceArr[1];
      if (xiaoshu.length == 1) {
        this.batchPriceObj.batchPrice = `${this.batchPriceObj.batchPrice}0`;
      }
    },
    //确认批量修改价格
    batchPriceSure() {
      if (!this.batchPriceObj.batchPrice) {
        this.batchPriceObj.batchPriceNullError = true;
        return;
      }
      if (!this.availableSpecList.length) {
        this.$message.error("请先添加规格数据!");
        return;
      }
      if (this.batchPriceObj.batchSelectType == "1") {
        this.specTabData.forEach((item, index) => {
          this.$set(this.specTabData[index], "price", this.batchPriceObj.batchPrice);
        });
        this.batchPriceObj.batchPriceShow = false;
        return;
      }
      //先看是否有初始值
      const everyHave = this.specTabData.every((item) => item.price);
      if (!everyHave) {
        this.$message.error("请先输入初始值!");
        return;
      }
      if (this.batchPriceObj.batchSelectType == "2") {
        this.specTabData.forEach((item) => {
          item.price = this.numAdd(item.price, this.batchPriceObj.batchPrice).toString();
        });
        this.batchPriceObj.batchPriceShow = false;
        this.specTabData = [...this.specTabData];
      }
      if (this.batchPriceObj.batchSelectType == "3") {
        //找到最小的数,先减一下看看会不会为负.
        const compareArr = [...this.specTabData];
        compareArr.sort((obj1, obj2) => {
          return obj1.price - obj2.price;
        });

        const minResult = this.numJian(compareArr[0].price, this.batchPriceObj.batchPrice);
        if (minResult < 0) {
          this.batchPriceObj.batchPriceFuError = true;
          return;
        }
        this.batchPriceObj.batchPriceFuError = false;
        this.specTabData.forEach((item) => {
          item.price = this.numJian(item.price, this.batchPriceObj.batchPrice).toString();
        });

        this.batchPriceObj.batchPriceShow = false;
        this.specTabData = [...this.specTabData];
      }
    },
    //批量修改起订量，根据分类控制小数位
    batchMinOrderQuantityInput() {
      // if (this.batchMinOrderQuantityObj.batchMinOrderQuantity.indexOf("-") != -1) {
      //   this.batchMinOrderQuantityObj.batchMinOrderQuantity = this.batchMinOrderQuantityObj.batchMinOrderQuantity.replaceAll("-", "");
      // }

      const { goodsPriceDigit, goodsAmountDigit } = this.shopConfig;

      let valueStr = `${this.batchMinOrderQuantityObj.batchMinOrderQuantity}`;
      valueStr = valueStr.replace(/[^\d.]/g, "");
      valueStr = valueStr.replace(/\.{2,}/g, ".");
      valueStr = valueStr.replace(".", "$#$");
      valueStr = valueStr.replace(/\./g, "");
      valueStr = valueStr.replace("$#$", ".");
      const reg = new RegExp("^(-)?(\\d{1,8})\\.(\\d{0,6}).*$");
      valueStr = valueStr.replace(reg, "$1$2.$3");
      valueStr = Number(valueStr) > 999999999 ? "999999999" : valueStr;
      if (valueStr.indexOf(".") < 0 && valueStr !== "" && valueStr !== "-") {
        // 以上已经过滤，此处控制的是如果没有小数点，首位不能为类似于 01、02的金额
        valueStr = parseFloat(valueStr);
      }
      if (goodsAmountDigit == 0 && valueStr == 0) {
        this.batchMinOrderQuantityObj.batchMinOrderQuantity = "";
        return;
      }
      this.batchMinOrderQuantityObj.batchMinOrderQuantity = valueStr;
      const priceArr = String(valueStr).split(".");
      if (priceArr.length <= 1) {
        return;
      }

      let xiaoshu = priceArr[1];
      if (goodsAmountDigit == 0) {
        valueStr = priceArr[0];
        this.batchMinOrderQuantityObj.batchMinOrderQuantity = valueStr;
        return;
      }
      if (xiaoshu.length > goodsPriceDigit) {
        xiaoshu = xiaoshu.substr(0, goodsPriceDigit);
        this.batchMinOrderQuantityObj.batchMinOrderQuantity = `${priceArr[0]}.${xiaoshu}`;
      }
    },
    //确认批量修改起订量
    batchMinOrderQuantitySure() {
      this.specTabData.forEach((item, index) => {
        this.$set(this.specTabData[index], "minOrderQuantity", this.batchMinOrderQuantityObj.batchMinOrderQuantity);
      });
      this.batchMinOrderQuantityObj.batchMinOrderQuantityShow = false;
      this.batchMinOrderQuantityObj.batchMinOrderQuantity = "";
    },
    //批量修改库存errortips
    batchStockInput() {
      this.batchStockObj.batchStockNullError = !this.batchStockObj.batchStock;
    },
    //批量修改库存,库存只允许整数
    batchStockChange() {
      const stockArr = this.batchStockObj.batchStock.split(".");
      if (stockArr.length <= 1) {
        return;
      }
      this.batchStockObj.batchStock = stockArr[0];
    },
    //确认批量修改库存
    batchStockSure() {
      if (!this.batchStockObj.batchStock) {
        this.batchStockObj.batchStockNullError = true;
        return;
      }

      if (!this.availableSpecList.length) {
        this.$message.error("请先添加规格数据!");
        return;
      }

      if (this.batchStockObj.batchSelectType == "1") {
        this.specTabData.forEach((item, index) => {
          this.$set(this.specTabData[index], "stock", this.batchStockObj.batchStock);
        });
        this.batchStockObj.batchStockShow = false;
        return;
      }

      const everyHave = this.specTabData.every((item) => item.stock);
      if (!everyHave) {
        this.$message.error("请先输入初始值!");
        return;
      }
      if (this.batchStockObj.batchSelectType == "2") {
        this.specTabData.forEach((item) => {
          item.stock = this.numAdd(item.stock, this.batchStockObj.batchStock).toString();
        });
        this.batchStockObj.batchStockShow = false;
        this.specTabData = [...this.specTabData];
      }
      if (this.batchStockObj.batchSelectType == "3") {
        //找到最小的数,先减一下看看会不会为负.
        const compareArr = [...this.specTabData];
        compareArr.sort((obj1, obj2) => {
          return obj1.stock - obj2.stock;
        });

        const minResult = this.numJian(compareArr[0].stock, this.batchStockObj.batchStock);
        if (minResult < 0) {
          this.batchStockObj.batchStockFuError = true;
          return;
        }
        this.batchStockObj.batchStockFuError = false;
        this.specTabData.forEach((item) => {
          item.stock = this.numJian(item.stock, this.batchStockObj.batchStock).toString();
        });

        this.batchStockObj.batchStockShow = false;
        this.specTabData = [...this.specTabData];
      }
    },
    //确认批量修改虚拟销量
    batchsalesVolumeUnrealSure() {
      this.specTabData.forEach((item, index) => {
        this.$set(this.specTabData[index], "salesVolumeUnreal", this.batchVirtualObj.batchsalesVolumeUnreal);
      });
      this.batchVirtualObj.batchsalesVolumeUnrealShow = false;
    },
    //加法计算
    numAdd(num1, num2) {
      const num1Digits = (num1.toString().split(".")[1] || "").length;
      const num2Digits = (num2.toString().split(".")[1] || "").length;
      const baseNum = Math.pow(10, Math.max(num1Digits, num2Digits));
      return (num1 * baseNum + num2 * baseNum) / baseNum;
    },
    //减法计算
    numJian(num1, num2) {
      const num1Digits = (num1.toString().split(".")[1] || "").length;
      const num2Digits = (num2.toString().split(".")[1] || "").length;
      const baseNum = Math.pow(10, Math.max(num1Digits, num2Digits));
      return (num1 * baseNum - num2 * baseNum) / baseNum;
    },
    //oa商品三种库存模式修改
    stockSelectChange(type, skuObj) {
      if (type != 1) {
        skuObj.stock = 0;
      }
      this.specTabData = [...this.specTabData];
    },
    //单个商品价钱输入的处理小数不超过六位
    skuPriceInput(obj) {
      if (obj.price.indexOf("-") != -1) {
        obj.price = obj.price.replaceAll("-", "");
      }
      const priceArr = obj.price.split(".");
      if (priceArr.length <= 1) {
        this.specTabData = [...this.specTabData];
        return;
      }
      const goodsPriceDigit = 6;
      console.log("goodsPriceDigit", goodsPriceDigit);
      let xiaoshu = priceArr[1];
      if (xiaoshu.length > goodsPriceDigit) {
        xiaoshu = xiaoshu.substr(0, goodsPriceDigit);
        obj.price = `${priceArr[0]}.${xiaoshu}`;
      }
      this.specTabData = [...this.specTabData];
    },
    //单个商品价钱输入完成.整数,补两个0,一位小数补一个0
    skuPriceChange(obj) {
      const priceArr = obj.price.split(".");
      //如果是整数,补两个0
      if (priceArr.length <= 1) {
        if (priceArr[0].length) {
          obj.price = `${obj.price}.00`;
        }
        this.specTabData = [...this.specTabData];
        return;
      }
      const xiaoshu = priceArr[1];
      if (xiaoshu.length == 1) {
        obj.price = `${obj.price}0`;
      }
      this.specTabData = [...this.specTabData];
    },
    //单个商品起订量控制，根据分类类型
    skuMinOrderQuantityInput(obj) {
      const { goodsPriceDigit, goodsAmountDigit } = this.shopConfig;

      let valueStr = `${obj.minOrderQuantity}`;
      valueStr = valueStr.replace(/[^\d.]/g, "");
      valueStr = valueStr.replace(/\.{2,}/g, ".");
      valueStr = valueStr.replace(".", "$#$");
      valueStr = valueStr.replace(/\./g, "");
      valueStr = valueStr.replace("$#$", ".");
      const reg = new RegExp("^(-)?(\\d{1,8})\\.(\\d{0,6}).*$");
      valueStr = valueStr.replace(reg, "$1$2.$3");
      valueStr = Number(valueStr) > 999999999 ? "999999999" : valueStr;
      if (valueStr.indexOf(".") < 0 && valueStr !== "" && valueStr !== "-") {
        // 以上已经过滤，此处控制的是如果没有小数点，首位不能为类似于 01、02的金额
        valueStr = parseFloat(valueStr);
      }
      if (goodsAmountDigit == 0 && valueStr == 0) {
        obj.minOrderQuantity = "";
        return;
      }
      obj.minOrderQuantity = valueStr;
      const priceArr = String(valueStr).split(".");
      if (priceArr.length <= 1) {
        this.specTabData = [...this.specTabData];
        return;
      }

      let xiaoshu = priceArr[1];
      if (goodsAmountDigit == 0) {
        valueStr = priceArr[0];
        obj.minOrderQuantity = valueStr;
        return;
      }
      if (xiaoshu.length > goodsPriceDigit) {
        xiaoshu = xiaoshu.substr(0, goodsPriceDigit);
        obj.minOrderQuantity = `${priceArr[0]}.${xiaoshu}`;
      }

      this.specTabData = [...this.specTabData];
    },
    //单个商品库存数修改,刷新列表,否则有可能不刷新
    skuStockInput() {
      this.specTabData = [...this.specTabData];
    },
    //单个商品库存数,取整
    skuStockChange(obj) {
      const stockArr = obj.stock.split(".");
      if (stockArr.length <= 1) {
        return;
      }
      obj.stock = stockArr[0];
      this.specTabData = [...this.specTabData];
    },
    skuRelationNoInput() {
      this.specTabData = [...this.specTabData];
    },
    // 上传图片之前
    uploadBefore(file) {
      const { size, type } = file;
      const isVerify = /(jpg|jpeg|png)$/.test(type);
      const isLt3M = size / 1024 / 1024 < 50;

      if (!isVerify) {
        this.$message.error("上传必须是JPG/JPEG/PNG/格式");
      } else if (!isLt3M) {
        this.$message.error("上传大小不能超过 50M");
      }
      return isVerify && isLt3M;
    },
    // 上传图片成功之后
    uploadSuccess(res, scope) {
      const {
        row: { specVal0 },
      } = scope;
      const {
        data: { url },
      } = res;

      this.specTabData.forEach((item, index) => {
        if (item.specVal0 == specVal0) {
          this.$set(this.specTabData[index], "skuPicUrl", url);
        }
      });
    },
    //编辑商品的时候,给现有sku赋值数据
    editProductSetSkusData(skuList) {
      this.specTabData = skuList.map((item) => {
        const skuSpecObj = {};
        const skuStrArr = item.skuSpecsIndex.trim().split(" ");

        for (let i = 0; i < skuStrArr.length; i++) {
          skuSpecObj[`specVal${i}`] = skuStrArr[i];
        }
        return {
          id: item.goodsId,
          price: item.marketPriceStr,
          stock: item.currQuantity,
          stockType: item.stockType,
          skuPicUrl: item.picUrl,
          skuUnit: item.mUnit,
          spec: item.spec,
          minOrderQuantity: item.minOrderQuantity,
          relationNo: item.relationNo,
          salesVolumeUnreal: item.salesVolumeUnreal,
          unitRatio: item.unitRatio,
          sUnit: item.sUnit == "0" ? "" : item.sUnit,
          ...skuSpecObj,
        };
      });
    },
    objectSpanMethod({ rowIndex, columnIndex }) {
      if (columnIndex === 0 || columnIndex === 1) {
        const row = this.availableSpecList.slice(1).reduce((sum, item) => {
          if (item.specValue.length !== 0) {
            return sum * item.specValue.length;
          } else {
            return sum;
          }
        }, 1);

        if (rowIndex % row === 0) {
          return {
            rowspan: row,
            colspan: 1,
          };
        } else {
          return {
            rowspan: 0,
            colspan: 0,
          };
        }
      }

      if (columnIndex === 2) {
        const row = this.availableSpecList.slice(2).reduce((sum, item) => {
          if (item.specValue.length !== 0) {
            return sum * item.specValue.length;
          } else {
            return sum;
          }
        }, 1);

        if (rowIndex % row === 0) {
          return {
            rowspan: row,
            colspan: 1,
          };
        } else {
          return {
            rowspan: 0,
            colspan: 0,
          };
        }
      }
    },
    subMitCheck() {
      //先判断必填字段
      const checkResult = this.specTabData.every((item) => {
        const isWriteUnit = item.skuUnit;
        const isWritePrice = this.isOA ? true : item.price;
        // const isWritePrice = true;

        let isWriteStock = true;
        if (item.stockType == 1) {
          isWriteStock = item.stock;
        }

        return isWriteUnit && isWritePrice && isWriteStock;
      });

      if (!checkResult) {
        this.$message.error(`请检查：计量单位,${this.isOA ? "" : "价格,"}库存是否填写!`);
        return;
      }

      const skuArr = this.specTabData.map((specItem) => {
        const skuIndex = `${specItem.specVal0 || ""} ${specItem.specVal1 || ""} ${specItem.specVal2 || ""}`.trim();

        return {
          id: specItem.id || "",
          relationNo: specItem.relationNo || "",
          price: specItem.price,
          stock: specItem.stock,
          stockType: specItem.stockType,
          skuPicUrl: specItem.skuPicUrl,
          skuUnit: specItem.skuUnit,
          spec: specItem.spec,
          minOrderQuantity: specItem.minOrderQuantity || 0,
          skuIndex,
          sUnit: specItem.sUnit,
          unitRatio: specItem.unitRatio,
          salesVolumeUnreal: specItem.salesVolumeUnreal,
        };
      });

      return JSON.stringify(skuArr);
    },
    //确认批量修改计量单位
    batchUnitRatioSure() {
      this.specTabData.forEach((item, index) => {
        this.$set(this.specTabData[index], "sUnit", this.batchUnitRatioObj.unit);
        this.$set(this.specTabData[index], "unitRatio", this.batchUnitRatioObj.ratio.replace(/\.$/, ""));
      });
      console.log(this.specTabData);
      this.batchUnitRatioObj.unitRatioShow = false;
    },
  },
};
</script>
<style lang="scss">
.batchTips {
  margin-top: 7px;
  margin-left: 7px;
  color: #ff0023;
  font-size: 12px;
}
.bottomBtnsBox {
  margin-top: 7px;
}
</style>
<style lang="scss" scoped>
.price-inventory-normal-container {
  .skuPic-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 120px;
    height: 120px;
    line-height: 120px;
    text-align: center;
  }
  .skuPic {
    width: 120px;
    height: 120px;
    display: block;
  }
  .xingTips {
    color: #ff0023;
  }
}
</style>
